/* eslint-disable max-len */
import { machine } from '../../../../entityModel';
import { useTranslation } from 'react-i18next';
import {
  TXT_ADD_MACHINE,
  TXT_CANCEL,
  TXT_CODE,
  TXT_EDIT_MACHINE,
  TXT_LABEL,
  TXT_SAVE,
  TXT_SAVING
} from '../../../../translations/translationConstants';
import {
  capitalizeFirstLetterEveryword
} from '../../../../shared/stringFunctions';
import {
  addMachineInput,
  updateMachineInput
} from '../../../../api';
import { useEffect } from 'react';
import { useState } from 'react';

export interface ManageMachineEditorProps {
  machine?: machine;
  onClose: () => void;
  onSave: (payload: addMachineInput | updateMachineInput) => void;
  isSaving: boolean;
  savingError?: string;
};

export const ManageMachineEditor = (props: ManageMachineEditorProps) => {
  const { t } = useTranslation();

  const [code, setCode] = useState<string | undefined>(props.machine ? props.machine.code : '');
  const [label, setLabel] = useState<string | undefined>(props.machine ? props.machine.label : '');

  const onCodeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.currentTarget.value);
  };

  const onLabelChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLabel(event.currentTarget.value);
  };

  const validate = () => {
    return !!code && !!label;
  };

  const [disabledSaveButton, setDisabledSaveButton] = useState(!validate());

  useEffect(() => {
    setDisabledSaveButton(!validate());
  }, [code, label]);

  const createAddInput = (): addMachineInput => {
    return {
      code: code!,
      label: label!
    };
  };

  const updateAddInput = (): updateMachineInput => {
    return {
      id: props.machine!.id!,
      code: code!,
      label: label!
    };
  };

  const onSaving = () => {
    if (!validate()) {
      return;
    }
    props.onSave(!props.machine ? createAddInput() : updateAddInput());
  };

  const lblTitle = t(props.machine ? TXT_EDIT_MACHINE : TXT_ADD_MACHINE).toUpperCase();
  const lblSave = t(TXT_SAVE);
  const lblSaving = t(TXT_SAVING);
  const lblCancel = t(TXT_CANCEL);

  const lblCode = `${capitalizeFirstLetterEveryword(t(TXT_CODE))}*`;
  const lblName = `${capitalizeFirstLetterEveryword(t(TXT_LABEL))}*`;

  return (
    <div className="modal fade" id="modal-machine-editor">
      <div className="modal-dialog">
        <form>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{lblTitle}</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>{lblCode}</label>
                <input type="text" onChange={onCodeChanged} value={code} className="form-control" />
              </div>
              <div className="form-group">
                <label>{lblName}</label>
                <input type="text" onChange={onLabelChanged} value={label} className="form-control" />
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={props.onClose} className="btn btn-default" data-dismiss="modal">{lblCancel}</button>
              <button type="button" onClick={onSaving} data-dismiss="modal" disabled={disabledSaveButton || props.isSaving} className="btn btn-primary">{props.isSaving ? lblSaving : lblSave}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
